/**
 * duplicate_group_controller.js — one group's Keep / Merge-in choices on /clients/duplicates (Stimulus).
 *
 * Each group in templates/clients/duplicates.html is a form: a "Keep" radio
 * and a "Merge in" checkbox per client. Keeping a client and merging it away
 * cannot both hold, so choosing the client to keep disables its own checkbox
 * and re-enables (and ticks) the one it replaced. The submit button names how
 * many clients will be merged and into whom, so the destructive step reads
 * plainly before it is taken. The server enforces the same rule regardless.
 *
 * Markup contract (per group):
 *   <form data-controller="duplicate-group">
 *     <input type="radio" data-duplicate-group-target="keep" data-name="..."
 *            data-action="change->duplicate-group#choose">
 *     <input type="checkbox" data-duplicate-group-target="merge"
 *            data-action="change->duplicate-group#count">
 *     <button data-duplicate-group-target="submit">
 *   </form>
 */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["keep", "merge", "submit"];

    connect() {
        this.count();
    }

    choose() {
        const kept = this.keptRadio()?.value;
        this.mergeTargets.forEach((box) => {
            const isKept = box.value === kept;
            if (box.disabled && !isKept) box.checked = true;
            box.disabled = isKept;
            if (isKept) box.checked = false;
        });
        this.count();
    }

    count() {
        const merging = this.mergeTargets.filter((box) => box.checked && !box.disabled).length;
        const name = this.keptRadio()?.dataset.name || 'the kept client';
        this.submitTarget.disabled = merging === 0;
        this.submitTarget.textContent = merging === 1
            ? `Merge 1 client into ${name}`
            : `Merge ${merging} clients into ${name}`;
    }

    keptRadio() {
        return this.keepTargets.find((radio) => radio.checked);
    }
}
